var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chinaArea-container"},[_c('el-cascader',{ref:"areaCascader",attrs:{"options":_vm.areaData,"filterable":"","clearable":"","placeholder":"请选择所属地区"},on:{"change":_vm.handleChange},model:{value:(_vm.selectedOptions),callback:function ($$v) {_vm.selectedOptions=$$v},expression:"selectedOptions"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }